import { render, staticRenderFns } from "./Timeago.vue?vue&type=template&id=094fa0e8"
import script from "./Timeago.vue?vue&type=script&lang=ts"
export * from "./Timeago.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('094fa0e8')) {
      api.createRecord('094fa0e8', component.options)
    } else {
      api.reload('094fa0e8', component.options)
    }
    module.hot.accept("./Timeago.vue?vue&type=template&id=094fa0e8", function () {
      api.rerender('094fa0e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Timeago.vue"
export default component.exports